import React from "react"

import { Box, Image, Typography } from "src/UILibrary"
import { useLoginContext } from "src/hooks/useLoginContext"
import { Adviser } from "src/openapi"

type Prop = {
  item: Adviser
  handleClick: any
}

export const AdviserItem = ({ item, handleClick }: Prop) => {
  const { getJobTitles } = useLoginContext()

  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      sx={{
        borderRadius: "10px",
        p: "10px",
        bgcolor: "white",
        ":hover": { opacity: 0.8, cursor: "pointer" },
      }}
      onClick={() => handleClick(item)}
    >
      <Image
        src={item ? (item.photoUrl as string) : ""}
        sx={{ height: "290px", maxHeight: "290px", width: "auto", bgcolor: "divider" }}
        imageStyle={{ width: "100%", height: "100%" }}
        alt=""
      />
      <Typography.SubHead
        sx={{ fontFamily: "Noto Sans JP !important", fontWeight: "700", mt: "20px" }}
      >
        {`${item.lastName} ${item.firstName}`}
      </Typography.SubHead>
      <Typography.DetailText
        sx={{
          fontFamily: "Noto Sans JP !important",

          ml: "5px",
          mt: "20px",
          color: "text.primary",
        }}
      >
        {getJobTitles(item)}
      </Typography.DetailText>
    </Box>
  )
}
